import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authApi } from '../api/auth';
import { RootState } from '../store/store';
import { UserUiConfigurationParameters } from 'ais-user-api/model/models';
import { UserConfiguration, UserProfileSettings } from 'ais-facade-api/api';
export interface UserI {
  message?: string;
  value: {
    email_verified?: boolean;
    family_name: string;
    given_name: string;
    preferred_username: string;
    sub: string;
  };
}

export interface AuthCheckI {
  value: {
    csrfToken: string;
    loggedIn: boolean;
    requestHandled: boolean;
  };
}

interface AuthStateI {
  user: UserI | null;
  auth: AuthCheckI | null;
  uiConfig: UserConfiguration | null;
  profile: UserProfileSettings | null;
}

const initialState: AuthStateI = {
  user: null,
  auth: null,
  uiConfig: null,
  profile: null,
};

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    logout: () => initialState,
    setUser: (state, action: PayloadAction<UserI>) => {
      state.user = action.payload;
    },
    setUiConfig: (state, action: PayloadAction<UserUiConfigurationParameters>) => {
      state.uiConfig = action.payload;
    },
    setUserProfile: (state, action: PayloadAction<UserProfileSettings | null>) => {
      state.profile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.userCheck.matchFulfilled, (state, { payload }) => {
      state.auth = payload;
    });
  },
});

export const { logout, setUser, setUiConfig, setUserProfile } = userSlice.actions;
export default userSlice.reducer;
export const currentUser = (state: RootState) => state.userSlice;
